import { render } from "./HistoriasPdf.vue?vue&type=template&id=60e9ff5e"
import script from "./HistoriasPdf.vue?vue&type=script&lang=js"
export * from "./HistoriasPdf.vue?vue&type=script&lang=js"

import "./HistoriasPdf.vue?vue&type=style&index=0&id=60e9ff5e&lang=css"
script.render = render

export default script